import { useState } from 'react'
import { TrainerPage } from '../trainer/page'
import { Chat } from './chat'
import { Library } from './library'
import { Playground } from './playground'
import { Prompts } from './prompts'
import styles from './studio.module.css'

const TABS = [
  { key: 'playground', label: 'Песочница' },
  { key: 'library', label: 'Эталоны' },
  { key: 'chat', label: 'Чат с Милой' },
  { key: 'prompts', label: 'Промпты' },
  { key: 'training', label: 'Тренировка' },
] as const

type TabKey = (typeof TABS)[number]['key']

export function StudioPage() {
  const [tab, setTab] = useState<TabKey>('playground')
  return (
    <div>
      <header className={styles.head}>
        <div>
          <h1>Студия</h1>
          <p className="muted">
            Настраиваем ИИ под стиль Людмилы: сравниваем варианты, правим и сохраняем эталоны, которые модель берёт за образец.
          </p>
        </div>
        <div className={styles.tabs} role="tablist" aria-label="Разделы Студии">
          {TABS.map((t) => (
            <button
              key={t.key}
              role="tab"
              id={`studio-tab-${t.key}`}
              aria-selected={tab === t.key}
              aria-controls={`studio-panel-${t.key}`}
              className={tab === t.key ? styles.tabActive : styles.tab}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </header>
      <section role="tabpanel" id={`studio-panel-${tab}`} aria-labelledby={`studio-tab-${tab}`}>
        {tab === 'playground' && <Playground />}
        {tab === 'library' && <Library />}
        {tab === 'chat' && <Chat />}
        {tab === 'prompts' && <Prompts />}
        {tab === 'training' && <TrainerPage />}
      </section>
    </div>
  )
}
